// Dependencies
import { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { sprintf } from 'sprintf-js';
import { evaluate } from 'mathjs';
import { FormikContextType, useFormikContext } from "formik";

// Types 
import { Types, Components } from '../../utils/types';

// Utils
import {  } from '../../utils/config'
import {  } from '../../utils/helpers'

const SimpleCalculator = ({name, type, fields, values, rules, variables, resultPrefixText, resultSuffixText, resultNote}: Components.SimpleCalculator) => {

    const [result, setResult] = useState<number>(0);
    const { setFieldValue }: FormikContextType<{}> = useFormikContext();

    const getVariables = () => {
        return {...variables, ...{result: new Intl.NumberFormat('sk-SK').format(result)}};
    } 

    useEffect(() => {

        let newResult = 0; 

        fields.forEach( (fieldName: string) => {

            const ruleName = values[fieldName];

            if ( rules && ruleName in rules ) {
                newResult += rules[ruleName];
            }

        });
        
        setResult( newResult );
        setFieldValue( name, newResult, false );

    }, [values]);

    const calculatorRef = useRef<any>(null);

    // Scroll into view
    useEffect(() => {
        setTimeout(() => {
            if ( ! _.isNull( calculatorRef.current ) ) {
                calculatorRef.current.scrollIntoView({block: "end", behavior: "smooth", inline: "nearest"}); // TODO:    More precise scrollIntoView (custom with offset)
            }
        }, 50)
    }, [result])


    return (
        <div ref={calculatorRef} className="calculator simple">
 
            {( resultPrefixText && _.isNumber( result ) && ! _.isNaN( result ) && result > 0 && _.isFinite( result ) ) &&
                <h2 className="calculator__result">
                    <span>{sprintf( resultPrefixText, getVariables() )}</span> <strong className="es-text--highlighted">{sprintf( resultSuffixText, getVariables() )}</strong>
                </h2>
            }
            
            {resultNote &&
                <small className="calculator__note es-text--gray">{sprintf( resultNote, getVariables() )}</small>
            }
            
        </div>
    ) 
}

const AdvancedCalculator = ({name, type, fields, values, variables, equation, resultPrefixText, resultSuffixText, resultNote}: Components.AdvancedCalculator) => {

    const [result, setResult] = useState<number>(0);
    const { setFieldValue }: FormikContextType<{}> = useFormikContext();

    const getVariables = () => {
        return {...variables, ...{result: new Intl.NumberFormat('sk-SK').format(result)}};
    }

    const getValues = () => {

        return Object.assign({}, ...fields.map( (fieldName: string ) => {
            
            if ( fieldName in values ) {
                
                //if ( _.isNumber( values[fieldName] ) ) {
                    return { 
                        [fieldName]: parseFloat( values[fieldName] )
                    };
                //}

            }

            return {};

        }));        

    }

    useEffect(() => {

        let newResult = 0; 

        const fieldsValues = getValues();
        
        if ( equation && Object.values( fieldsValues ).length === fields.length  ) {
            newResult = evaluate( sprintf( equation, {...fieldsValues, ...variables} ) );
        }

        setResult( newResult );
        // setFieldValue( name, newResult );

    }, [result, values]);    

    const calculatorRef = useRef<any>(null);

    // Scroll into view
    useEffect(() => {
        setTimeout(() => {
            if ( ! _.isNull( calculatorRef.current ) ) {
                // calculatorRef.current.scrollIntoView({block: "end", behavior: "smooth", inline: "nearest"}); // TODO:    More precise scrollIntoView (custom with offset)
            }
        }, 50)
    }, [result])
    
    return (
        <div ref={calculatorRef} className="calculator advanced">

            {( resultPrefixText && _.isNumber( result ) && ! _.isNaN( result ) && result > 0 && _.isFinite( result ) ) &&
                <h2 className="calculator__result">
                    <span>{sprintf( resultPrefixText, getVariables() )}</span> <strong className="es-text--highlighted">{sprintf( resultSuffixText, getVariables() )}</strong>
                </h2>
            }
 
            <small className="calculator__note es-text--gray">{resultNote}</small>
            
        </div>
    ) 
}
 
export const Calculator = ({type, ...props}: Components.Calculator) => {

    const { values }: FormikContextType<{}> = useFormikContext();

    switch ( type ) {
 
        case 'simple':
            return <SimpleCalculator type={type} values={values} {...props} />;
        
        case 'advanced':
            return <AdvancedCalculator type={type} values={values} {...props} />;
 
        default:
            return null; 
    }

}